<template>
    <div :key="0">
        <v-dialog v-model="sendToManagerDialog" persistent max-width="500">
            <v-card>
                <v-card-title class="headline">Отправить отчет менеджеру ТП?</v-card-title>
                <v-card-text>
                    После того как вы отправите отчет, вы не сможете повлиять на акт проверки.
                    <div v-if="!!accountMode">
                        <v-textarea v-model="report.mainAccountComment" @change="change" placeholder="Оставьте общий комментарий для менеджера ТП"></v-textarea>
                    </div>
                </v-card-text>
                <v-progress-linear v-if="sendManagerLoader" indeterminate color="primary"></v-progress-linear>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" :disabled="sendManagerLoader" text @click="sendToManagerDialog = false">
                        Не отправлять
                    </v-btn>
                    <v-btn color="green darken-1" :disabled="sendManagerLoader || noComment" text @click="sendToManager">Отправить
                        менеджеру
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-row>
            <v-col cols="12">
                <div class="title">Выявленные нарушения</div>
            </v-col>
        </v-row>

        <v-data-table
                v-if="report"
                :headers="mainHeaders"
                :items="reportPoints"
                item-key="itemKey"
                dense
                :key="tableKey"
                search="1"
                group-by="cat_id"
                hide-default-footer
                :custom-filter="showNoSearch"
                class="elevation-1"
                :items-per-page="150"
        >
            <template v-slot:group.header="{ group, isOpen, toggle, items }">
                <td class="yellow darken-2 pt-2 pb-2" :colspan="1">{{ getCatname(group) }}</td>
                <!--  -->
                <td class="yellow darken-2 pt-2 pb-2 text-center" width="95" v-if="!!showAdminUI">{{ getGroupData(group) | floatNumber }}
                </td>
                <!--  -->
                <td class="yellow darken-2 pt-2 pb-2 text-center" width="124" v-if="!!showAdminUI">
                    <v-layout align-content-center>
                        <v-text-field background-color="white" class="mt-3"
                                      :step="(+(group) === 8 || +(group) === 18) ? 0.1 : 1" type="number" dense
                                      v-model="report.final.penaltyResult[group].correction"
                                      :disabled="!!ukMode"
                                      @change="penaltyCalculator"></v-text-field>
                    </v-layout>
                </td>
                <!--  -->
                <td class="yellow darken-2 pt-2 pb-2 text-center" width="59">{{ report.final.penaltyResult[group].count | floatNumber }}</td>
                <!--  -->
                <td class="yellow darken-2 pt-2 pb-2 text-center" width="111"
                    v-if="(!!showAdminUI && !!fullRows) || !!accountMode">
                    <v-layout align-content-center>
                        <v-text-field background-color="white" class="mt-3"
                                      :step="[8, 18, 21, 22, 23].includes(+(group)) ? 0.1 : 1" type="number" dense
                                      :disabled="!!ukMode || stage !== 'C30:1'"
                                      v-model="report.final.penaltyResult[group].minus"
                                      :min="0" :max="report.final.penaltyResult[group].count"
                                      @change="penaltyCalculator"></v-text-field>
                    </v-layout>
                </td>
                <!--  -->
                <td class="yellow darken-2 pt-2 pb-2 text-center"
                    width="59"
                    v-if="(!!showAdminUI && !!fullRows) || !!accountMode">
                    {{ report.final.penaltyResult[group].total | floatNumber }}
                </td>
                <!--  -->
                <td class="yellow darken-2 pt-2 pb-2 text-center" width="52"
                    v-if="(!!showAdminUI && !!fullRows) || !!accountMode">
                    <account-reuslt-comment :mode="subMode" v-model="report.final.penaltyResult[group].comment"
                                            @change="penaltyCalculator" :stage="stage"
                                            :minus="report.final.penaltyResult[group].minus"></account-reuslt-comment>
                </td>
            </template>
            <template v-slot:item.act_text="{ item }">
                {{ item.act_text || item.question}}
            </template>
            <template v-slot:footer="{ footer }">
                <div class="orange darken-2">
                    <table>
                        <tbody>
                        <tr>
                            <td class="text-right"><b>ИТОГО:</b></td>
                            <!--  -->
                            <td class="text-center" width="95" v-if="!!showAdminUI">{{ report.final.penaltySumms.auto |
                                floatNumber }}
                            </td>
                            <!--  -->
                            <td class="text-center" width="124" v-if="!!showAdminUI">{{ report.final.penaltySumms.corr |
                                floatNumber }}
                            </td>
                            <!--  -->
                            <td class="text-center" width="59">{{ report.final.penaltySumms.count | floatNumber }}</td>
                            <!--  -->
                            <td width="111"
                                v-if="(!!showAdminUI && !!fullRows) || !!accountMode">
                                &nbsp;
                            </td>
                            <!--  -->
                            <td class="text-center" width="59"
                                v-if="(!!showAdminUI && !!fullRows) || !!accountMode">{{
                                report.final.penaltySumms.total | floatNumber }}
                            </td>
                            <!--  -->
                            <td width="56"
                                v-if="(!!showAdminUI && !!fullRows) || !!accountMode"></td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </template>
        </v-data-table>
        <v-row class="text-center">
            <v-col cols="12">
                <v-btn @click="penaltyCalculator" v-if="!!showAdminUI" color="info">Пересчитать ШБ</v-btn>
                <v-btn @click="sendToManagerPre" v-if="!!accountMode && stage === 'C30:1'" :disabled="!commented" color="info">Отправить
                    отчет менеджеру ТП
                </v-btn>
            </v-col>
        </v-row>
    </div>
</template>

<script>
  import AccountReusltComment from './accountReusltComment'
  import Decimal from "decimal.js";

  export default {
    name: 'penaltyTable',
    components: { AccountReusltComment },
    props: ['value', 'mode', 'stage'],
    data () {
      return {
        commented: false,
        subMode: this.mode,
        sendManagerLoader: false,
        sendToManagerDialog: false,
        report: this.value,
        cats: [],
        tableKey: 20,
        headers: [
          { text: 'Нарушение', align: 'left', value: 'act_text', sortable: false, },
          { text: 'Начислено ШБ', value: 'penalty', align: 'center', sortable: false, width: 100, },
          { text: 'Коррекция', value: 'penalty_correction', align: 'center', sortable: false, width: 100 },
          { text: 'Итог', value: 'penalty_final', sortable: false, align: 'center', width: 52 },
          { text: 'Списать', value: 'minus', sortable: false, align: 'center', width: 52 },
          { text: 'Итог', value: 'result', sortable: false, align: 'center', width: 52 },
          { text: '', value: 'comment', sortable: false, align: 'center', width: 52 },
        ],
      }
    },
    filters: {
      floatNumber (val) {
        if (isNaN(val) || val === null) {
          return 0
        }
        return +(val).toFixed(2)
      }
    },
    computed: {
      reportPoints() {
        return (this.report && this.report.points || []).filter(item => item.cat_id > 0)
      },
      noComment() {
        return !this.report.mainAccountComment || this.report.mainAccountComment === null || this.report.mainAccountComment.replace(/\s/g, '') === ''
      },
      fullRows() {
        return this.stage === 'C30:1' || this.stage === 'C30:2' || this.stage === 'C30:WON'
      },
      accountCommentEmpty () {
        return this.report.final.accountComment === null || this.report.final.accountComment === undefined || this.report.final.accountComment.toString().replace(/\s/g, '') === ''
      },
      mainHeaders () {
        console.log('create heades', this.mode)

        if (this.mode === 'account' || (this.mode === 'manager' && (this.stage === 'C30:2' || this.stage === 'C30:WON'))) return [
          { text: 'Нарушение', align: 'left', value: 'act_text', sortable: false, },
          { text: 'Начислено ШБ', value: 'penalty_final', sortable: false, align: 'center', },
          { text: 'Списать ШБ', value: 'minus', sortable: false, align: 'center', },
          { text: 'Итог', value: 'penalty_total', sortable: false, align: 'center', },
        ]
        if (this.mode === 'manager' || !this.mode) {
          if (this.stage === 'C30:1') {
            return [
              { text: 'Нарушение', align: 'left', value: 'act_text', sortable: false, },
              { text: 'Начислено ШБ', value: 'penalty', align: 'center', sortable: false, },
              { text: 'Коррекция', value: 'penalty_correction', align: 'center', sortable: false, },
              { text: 'Итог', value: 'penalty_final', sortable: false, align: 'center', },
              { text: 'Списать', value: 'minus', sortable: false, align: 'center', },
              { text: 'Итог', value: 'result', sortable: false, align: 'center', },
              { text: '', value: '', sortable: false, align: 'center', },
            ]
          }
          if ( (this.stage === 'C30:2' || this.stage === 'C30:WON')) {
            return [
              { text: 'Нарушение', align: 'left', value: 'act_text', sortable: false, },
              { text: 'Начислено ШБ', value: 'penalty', align: 'center', sortable: false,  },
              { text: 'Коррекция', value: 'penalty_correction', align: 'center', sortable: false, },
              { text: 'Итог', value: 'penalty_final', sortable: false, align: 'center', },
              { text: 'Списать', value: 'minus', sortable: false, align: 'center', },
              { text: 'Итог', value: 'result', sortable: false, align: 'center', },
              { text: '', value: '', sortable: false, align: 'center', },
            ]
          }
          return [
            { text: 'Нарушение', align: 'left', value: 'act_text', sortable: false, },
            {
              text: 'Начислено ШБ',
              value: 'penalty',
              align: 'center',
              sortable: false,
              width: 100,
              showFor: 'manager'
            },
            {
              text: 'Коррекция',
              value: 'penalty_correction',
              align: 'center',
              sortable: false,
              width: 100,
              showFor: 'manager'
            },
            { text: 'Итог', value: 'penalty_final', sortable: false, align: 'center', width: 52 },
          ]
        }
        if (this.mode === 'franch' || this.mode === 'uk') return [
          { text: 'Нарушение', align: 'left', value: 'act_text', sortable: false, },
          { text: 'Итог', value: 'penalty_final', sortable: false, align: 'center', width: 100 },
        ]
        return this.headers
      },
      accountMode () {
        return this.mode === 'account'
      },
      franchMode () {
        return this.mode === 'franch'
      },
      ukMode () {
        return this.mode === 'uk'
      },
      showAdminUI () {
        return this.mode === 'manager' || this.mode === undefined || this.mode === null
      },
    },
    methods: {
      getGroupData(group){
        return this.report
            && this.report.final
            && this.report.final.penaltyResult
            && this.report.final.penaltyResult[group]
            && this.report.final.penaltyResult[group].result || 0;
      },
      async sendToManager () {
        await this.change()
        this.sendManagerLoader = true
        try {
          const r = await this.$http.post(`${this.$store.getters.bxapi}crm.deal.update`, {
            id: this.report.dealData.deal_id_bx,
            fields: {
              STAGE_ID: `C30:2`
            }
          })
          this.sendManagerLoader = false
          this.deal.STAGE_ID = `C30:2`
        } catch (e) {
          console.log(e)
        }
        location.reload()
        this.sendToManagerDialog = false
      },
      sendToManagerPre () {
        this.sendToManagerDialog = true
      },
      penaltyCalculator: function () {
        for (let i in this.report.points) {
          //TODO: ИСКЛЮЧЕНИЕ ЗАЯВКИ ДОГОВОРА ИЗ 18 КАТЕГОРИИ. УБРАТЬ В СЛЕДУЮЩЕМ МЕСЯЦЕ
          if (this.report.points[i].question_id === 10 && this.report.points[i].cat_id === 18 && this.report.points[i].question.indexOf('заявку') > -1) this.report.points[i].cat_id = 6
        }

        let questions = this.report.points.filter(item => !item.exclude && item.point < 1 && item.admin_block_id !== 9)

        for (let i in this.report.final.penaltyResult) {
          this.report.final.penaltyResult[i].summ = 0
          this.report.final.penaltyResult[i].count = 0
          this.report.final.penaltyResult[i].result = 0
          this.report.final.penaltyResult[i].total = 0
        }

        this.report.final.penaltyResult['8'].zones = {
          outside: 0,
          reception: 0,
          client: 0,
          wc: 0,
          garage: 0,
        }

        this.report.final.penaltyResult['18'].docs = {
          10: 0,
          63: 0,
          65: 0
        }

        for (let i in questions) {
          if (questions[i].cat_id === 1) {
            this.report.final.penaltyResult['1'].summ += questions[i].point_to_reports
            this.report.final.penaltyResult['1'].result = this.report.final.penaltyResult['1'].summ < 0 ? 1 : 0
            this.report.final.penaltyResult['1'].count = +(this.report.final.penaltyResult['1'].result) + +(this.report.final.penaltyResult['1'].correction)
            this.report.final.penaltyResult['1'].total = +(this.report.final.penaltyResult['1'].result) + +(this.report.final.penaltyResult['1'].correction) - +(this.report.final.penaltyResult['1'].minus)
          }

          if (questions[i].cat_id === 2) {
            this.report.final.penaltyResult['2'].summ += 1
            this.report.final.penaltyResult['2'].result = this.report.final.penaltyResult['2'].summ > 0 ? 1 : 0
            this.report.final.penaltyResult['2'].count = +(this.report.final.penaltyResult['2'].result) + +(this.report.final.penaltyResult['2'].correction)
            this.report.final.penaltyResult['2'].total = +(this.report.final.penaltyResult['2'].result) + +(this.report.final.penaltyResult['2'].correction) - +(this.report.final.penaltyResult['2'].minus)
          }

          if (questions[i].cat_id === 3) {
            this.report.final.penaltyResult['3'].summ += 1
            this.report.final.penaltyResult['3'].result = this.report.final.penaltyResult[3].summ > 0 ? 1 : 0
            this.report.final.penaltyResult['3'].count = +(this.report.final.penaltyResult['3'].result) + +(this.report.final.penaltyResult['3'].correction)
            this.report.final.penaltyResult['3'].total = +(this.report.final.penaltyResult['3'].result) + +(this.report.final.penaltyResult['3'].correction) - +(this.report.final.penaltyResult['3'].minus)
          }
          if (questions[i].cat_id === 4) {
            this.report.final.penaltyResult['4'].summ += 1
            this.report.final.penaltyResult['4'].result = this.report.final.penaltyResult['4'].summ
            this.report.final.penaltyResult['4'].count = +(this.report.final.penaltyResult['4'].result) + +(this.report.final.penaltyResult['4'].correction)
            this.report.final.penaltyResult['4'].total = +(this.report.final.penaltyResult['4'].result) + +(this.report.final.penaltyResult['4'].correction) - +(this.report.final.penaltyResult['4'].minus)
          }

          if (questions[i].cat_id === 6) {
            this.report.final.penaltyResult['6'].summ += 1
            this.report.final.penaltyResult['6'].result = this.report.final.penaltyResult['6'].summ
            this.report.final.penaltyResult['6'].count = +(this.report.final.penaltyResult['6'].result) + +(this.report.final.penaltyResult['6'].correction)
            this.report.final.penaltyResult['6'].total = +(this.report.final.penaltyResult['6'].result) + +(this.report.final.penaltyResult['6'].correction) - +(this.report.final.penaltyResult['6'].minus)
          }
          if (questions[i].cat_id === 7) {
            this.report.final.penaltyResult['7'].summ += 1
            this.report.final.penaltyResult['7'].result = this.report.final.penaltyResult[7].summ > 5 ? 0 : 0
            this.report.final.penaltyResult['7'].count = +(this.report.final.penaltyResult['7'].result) + +(this.report.final.penaltyResult['7'].correction)
            this.report.final.penaltyResult['7'].total = +(this.report.final.penaltyResult['7'].result) + +(this.report.final.penaltyResult['7'].correction) - +(this.report.final.penaltyResult['7'].minus)
          }
          if (questions[i].cat_id === 8) {

            if (questions[i].admin_block_id === 1 || questions[i].admin_block_id === 2) this.report.final.penaltyResult['8'].zones.outside += 1
            if (questions[i].admin_block_id === 3) this.report.final.penaltyResult['8'].zones.reception += 1
            if (questions[i].admin_block_id === 5) this.report.final.penaltyResult['8'].zones.client += 1
            if (questions[i].admin_block_id === 6) this.report.final.penaltyResult['8'].zones.wc += 1
            if (questions[i].admin_block_id === 7) this.report.final.penaltyResult['8'].zones.garage += 1

            let zoneCount = 0
            for (let j in this.report.final.penaltyResult['8'].zones) {
              if (this.report.final.penaltyResult['8'].zones[j] > 0) zoneCount += 1
            }

            this.report.final.penaltyResult['8'].result = +(zoneCount) * 0.1
            this.report.final.penaltyResult['8'].count = +(this.report.final.penaltyResult['8'].result) + +(this.report.final.penaltyResult['8'].correction)
            this.report.final.penaltyResult['8'].total = +(this.report.final.penaltyResult['8'].result) + +(this.report.final.penaltyResult['8'].correction) - +(this.report.final.penaltyResult['8'].minus)
          }

          if (questions[i].cat_id === 18) {
            if (questions[i].parent_id === 10) this.report.final.penaltyResult['18'].docs['10'] += 1
            if (questions[i].parent_id === 63) this.report.final.penaltyResult['18'].docs['63'] += 1
            if (questions[i].parent_id === 65) this.report.final.penaltyResult['18'].docs['65'] += 1

            let docsCount = 0

            for (let j in this.report.final.penaltyResult['18'].docs) {
              if (this.report.final.penaltyResult['18'].docs[j] > 0) docsCount += 1
            }

            this.report.final.penaltyResult['18'].result = +(docsCount) * 0.1
            this.report.final.penaltyResult['18'].count = +(this.report.final.penaltyResult['18'].result) + +(this.report.final.penaltyResult['18'].correction)
            this.report.final.penaltyResult['18'].total = +(this.report.final.penaltyResult['18'].result) + +(this.report.final.penaltyResult['18'].correction) - +(this.report.final.penaltyResult['18'].minus)
          }

          if (questions[i].cat_id === 20) {
            this.report.final.penaltyResult['20'].summ += 1
            this.report.final.penaltyResult['20'].result = this.report.final.penaltyResult['20'].summ > 0 ? 1 : 0
            this.report.final.penaltyResult['20'].count = +(this.report.final.penaltyResult['20'].result) + +(this.report.final.penaltyResult['20'].correction)
            this.report.final.penaltyResult['20'].total = +(this.report.final.penaltyResult['20'].result) + +(this.report.final.penaltyResult['20'].correction) - +(this.report.final.penaltyResult['20'].minus)
          }


          if (questions[i].cat_id === 21) {
            this.report.final.penaltyResult['21'].summ = new Decimal(this.report.final.penaltyResult['21'].summ).plus(0.1).toNumber();
            this.report.final.penaltyResult['21'].result = new Decimal(this.report.final.penaltyResult['21'].summ).toNumber();
            this.report.final.penaltyResult['21'].count = new Decimal(this.report.final.penaltyResult['21'].result).plus(this.report.final.penaltyResult['21'].correction).toNumber();
            this.report.final.penaltyResult['21'].total = new Decimal(this.report.final.penaltyResult['21'].count).minus(this.report.final.penaltyResult['21'].minus).toNumber();
          }


          if (questions[i].cat_id === 22) {
            this.report.final.penaltyResult['22'].summ = new Decimal(this.report.final.penaltyResult['22'].summ).plus(0.1).toNumber();
            this.report.final.penaltyResult['22'].result = new Decimal(this.report.final.penaltyResult['22'].summ).toNumber();
            this.report.final.penaltyResult['22'].count = new Decimal(this.report.final.penaltyResult['22'].result).plus(this.report.final.penaltyResult['22'].correction).toNumber();
            this.report.final.penaltyResult['22'].total = new Decimal(this.report.final.penaltyResult['22'].count).minus(this.report.final.penaltyResult['22'].minus).toNumber();
          }


          if (questions[i].cat_id === 23) {
            this.report.final.penaltyResult['23'].summ = new Decimal(this.report.final.penaltyResult['23'].summ).plus(0.1).toNumber();
            this.report.final.penaltyResult['23'].result = new Decimal(this.report.final.penaltyResult['23'].summ).toNumber();
            this.report.final.penaltyResult['23'].count = new Decimal(this.report.final.penaltyResult['23'].result).plus(this.report.final.penaltyResult['23'].correction).toNumber();
            this.report.final.penaltyResult['23'].total = new Decimal(this.report.final.penaltyResult['23'].count).minus(this.report.final.penaltyResult['23'].minus).toNumber();
          }

        }

        this.report.final.penaltySumms = {
          auto: 0,
          corr: 0,
          count: 0,
          minus: 0,
          total: 0,
        }

        let commentedInLoop = true

        for (let i in this.report.final.penaltyResult) {
          this.report.final.penaltySumms.auto = +(this.report.final.penaltySumms.auto) + +(this.report.final.penaltyResult[i].result)
          this.report.final.penaltySumms.corr = +(this.report.final.penaltySumms.corr) + +(this.report.final.penaltyResult[i].correction)
          if (this.report.final.penaltyResult[i].count !== undefined) this.report.final.penaltySumms.count = +(this.report.final.penaltySumms.count) + +(this.report.final.penaltyResult[i].count)

          this.report.final.penaltySumms.minus = +(this.report.final.penaltySumms.minus) + +(this.report.final.penaltyResult[i].minus)
          if (this.report.final.penaltyResult[i].total !== undefined) this.report.final.penaltySumms.total = +(this.report.final.penaltySumms.total) + +(this.report.final.penaltyResult[i].total)

          if (this.report.final.penaltyResult[i].comment !== undefined && this.report.final.penaltyResult[i].comment !== null && this.report.final.penaltyResult[i].minus > 0) {
            if (this.report.final.penaltyResult[i].comment === null || this.report.final.penaltyResult[i].comment === '') {
              console.log('rule 1')
              commentedInLoop = false
            } else {
              if (this.report.final.penaltyResult[i].comment.replace(/\s/g, '') === '') {
                console.log('rule 2')
                commentedInLoop = false
              }
            }
          } else if (+(this.report.final.penaltyResult[i].minus) === 0) {
            console.log('rule 2.5')
          } else {
            console.log({
              cmm: this.report.final.penaltyResult[i].comment,
              min: this.report.final.penaltyResult[i].minus
            })
            console.log(this.report.final.penaltyResult[i])
            console.log('rule 3')
            commentedInLoop = false
          }
        }

        if (!!commentedInLoop) {
          this.commented = true
        } else {
          this.commented = false
        }
        console.log('commented', commentedInLoop)
        //this.report.final.penaltyResult = JSON.parse(JSON.stringify(penaltyResult))
        this.tableKey = 101 + Math.floor((201 - 101) * Math.random())
        this.change()
      },
      showNoSearch (value, search, item) {
        return !item.exclude && item.point < 1 && item.admin_block_id !== 9
      }
      ,
      change () {
        this.$emit('input', this.report)
        this.$nextTick(function () {
          this.$emit('change')
        })
      }
      ,
      getCatname (val) {
        let name = 0
        for (let cat of this.cats) {
          if (cat.cat_id === +(val)) {
            name = cat.cat_name
            return name
            break
          }
        }

      },
      async getCats () {
        try {
          const r = await this.$http.get(`${this.$store.getters.api}v3/bots/shopper/cats`)
          this.cats = r.data
          console.log('cats', this.cats)
        } catch (e) {
          console.log(e)
        }
      },
      createCommentData: function () {
        for (let i in this.report.final.penaltyResult) {
          if (this.report.final.penaltyResult[i].comment === undefined) this.report.final.penaltyResult[i].comment = ''
        }
      }
    },
    mounted () {
      this.getCats()
      this.createCommentData()
      this.penaltyCalculator()
      //let questions = this.report.points.filter(item => !item.exclude && item.point < 1 && item.admin_block_id !== 9)
      //console.log('QSTSS', questions)
    }
  }
</script>

<style scoped>

</style>
